import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import { NotificationButtonElement } from '../../models/formula.model';

import API from '../../services/api';

import useGetCurrentMessageContent from '../message-content/useGetCurrentMessageContent';
import formulaButtonsKeys from './_queryKeys';

const getFormulaButtons = async (
    formulaId: number,
    messageContentId?: string,
): Promise<NotificationButtonElement[]> => {
    const { data } = await API.fetchFormulaButtons(formulaId, {
        message_content_id: messageContentId,
    });
    return data;
};

export default function useQueryFormulaButtons(
    formulaId?: number, // Make formulaId optional
): UseQueryResult<NotificationButtonElement[], BaseError> {
    const { currentMessageContentId } = useGetCurrentMessageContent();
    return useQuery<NotificationButtonElement[], BaseError>(
        {
            queryKey: formulaButtonsKeys.formulaButtons(
                formulaId || 0,
                currentMessageContentId,
            ),

            // The query key still needs to be valid
            queryFn: () =>
                getFormulaButtons(formulaId!, currentMessageContentId),
            staleTime: 2 * 60 * 60,
            enabled: !!formulaId, // The query only runs if formulaId is defined
        }, // Non-null assertion since enabled prevents this from running if formulaId is null
    );
}
